import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SectionLevelProvider, useNextSectionLevel } from './sectionLevel';
export var Section = React.forwardRef(function Section(_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement("section", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: useNextSectionLevel()
  }, children));
});
Section.displayName = 'Section';
export var Article = React.forwardRef(function Article(_ref2, ref) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React.createElement("article", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: useNextSectionLevel()
  }, children));
});
Article.displayName = 'Article';
export var Aside = React.forwardRef(function Aside(_ref3, ref) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement("aside", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: useNextSectionLevel()
  }, children));
});
Aside.displayName = 'Aside';
export var Nav = React.forwardRef(function Nav(_ref4, ref) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement("nav", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: useNextSectionLevel()
  }, children));
});
Nav.displayName = 'Nav';